/**
 * Layout helpers for Phaser text on both the 800px desktop and the 400px
 * mobile canvas: shrink text to fit a width, and stack items vertically so
 * screens don't rely on hand-tuned y positions that collide.
 */

const MIN_FONT_PX = 8; // Press Start 2P legibility floor (see FontScale)
const NARROW_WIDTH = 600;

/** Shrink `text`'s font (not below 8px) until it is at most `maxWidth` wide. */
export function fitText(text, maxWidth) {
  let size = parseInt(text.style.fontSize, 10);
  while (text.width > maxWidth && size > MIN_FONT_PX) {
    size -= 1;
    text.setFontSize(size);
  }
  return text;
}

/**
 * Place items top to bottom from `y` (origin-y 0 texts/objects, or
 * { space: n } spacers). Returns the y just below the last item.
 */
export function stack(items, y, gap = 8) {
  let cursor = y;
  items.forEach((item, i) => {
    if (i > 0) cursor += gap;
    if (item.space !== undefined) {
      cursor += item.space;
      return;
    }
    item.setY(cursor);
    cursor += item.height;
  });
  return cursor;
}

/** The mobile layout (400px wide canvas). */
export function isNarrow(scene) {
  return scene._W < NARROW_WIDTH;
}
